import React from "react";

type HelpLinkType = "article" | "contact" | "default";

type HelpLinkProps = {
  type: HelpLinkType;
  children: React.ReactNode;
  articleId?: string;
  newTab?: boolean;
  className?: string;
};

export const helpCenterUrl = "https://readlee.zendesk.com/hc/en-us/";
export const contactSupportSuffix = "requests/new";

const getSuffix = (type: HelpLinkType, articleId?: string): string => {
  switch (type) {
    case "article":
      return `articles/${articleId}`;
    case "contact":
      return contactSupportSuffix;
    default:
      return "";
  }
};

const HelpLink = ({ type, articleId, newTab = true, children, ...passThroughProps }: HelpLinkProps) => {
  const newTabProps = newTab ? { target: "blank", rel: "noopener noreferrer" } : {};

  return (
    <a
      href={`${helpCenterUrl}${getSuffix(type, articleId)}`}
      {...newTabProps}
      {...passThroughProps}
      style={{ textDecoration: "none" }}
    >
      {children}
    </a>
  );
};

export default HelpLink;
